// Pipeline stage definitions used by the Leads board, filters, and modals.
// Kept as a plain module (no React) so it can be imported by any leaf
// component without dragging the whole modal tree along.
export const LEAD_STAGES = [
  { id: 'raw', label: 'New Leads', color: 'bg-slate-500', emoji: '📥' },
  { id: 'contacted', label: 'Contacted', color: 'bg-blue-500', emoji: '📞' },
  { id: 'engaged', label: 'Engaged', color: 'bg-cyan-500', emoji: '💬' },
  { id: 'qualified', label: 'Qualified', color: 'bg-purple-500', emoji: '✅' },
  { id: 'mql', label: 'MQL', color: 'bg-indigo-500', emoji: '📊' },
  { id: 'sql', label: 'SQL', color: 'bg-violet-500', emoji: '🎯' },
  { id: 'mature', label: 'Mature', color: 'bg-amber-500', emoji: '⭐' },
  { id: 'proposal_sent', label: 'Proposal', color: 'bg-orange-500', emoji: '📝' },
  { id: 'negotiation', label: 'Negotiation', color: 'bg-rose-500', emoji: '🤝' },
  { id: 'won', label: 'Won', color: 'bg-emerald-500', emoji: '🏆' },
  { id: 'lost', label: 'Lost', color: 'bg-red-500', emoji: '❌' },
];
